import React from "react";
import { useParams, Link } from "react-router-dom";
import { FaCheck, FaInfoCircle, FaArrowRight } from "react-icons/fa";
import slide2 from '../images/slide2.webp';
import logon from '../images/logon.webp';

// Información de los planes
const plansData = {
  comprehensive: {
    title: "Comprehensive Care Plan",
    description:
      "A dignified farewell with personalized support every step of the way.",
    features: [
      "Professional funeral director services",
      "Use of facilities for visitation and ceremony",
      "High-quality casket or cremation urn",
      "Transportation services",
      "Memorial package and keepsakes",
      "Assistance with obituary and death certificates",
      "Grief support resources",
      "24/7 care and support",
    ],
    whyChoose: [
      "Servicios profesionales y dedicados",
      "Apoyo emocional continuo",
      "Asistencia legal para todos los trámites",
      "Disponibilidad las 24 horas",
    ],
    image: "mputadora-programacion-tecnologia-digital-codificacion-prueba-ilustracion-vector-plano-aislado_613284-3265.jpg?w=900&t=st=1725475504~exp=1725476104~hmac=f1e86850d457003ccee0e09cf0dccd6bae4803ddfa470304af083b2d79a8302f",
  },
  eco: {
    title: "Plan Eco",
    description:
      "Un plan ecológico diseñado para reducir el impacto ambiental, con servicios de cremación y urnas biodegradables.",
    features: [
      "Servicios de cremación ecológica",
      "Urnas biodegradables",
      "Transporte eco-friendly",
      "Asistencia para certificados",
      "Recursos de apoyo para el duelo",
    ],
    whyChoose: [
      "Respetuoso con el medio ambiente",
      "Soluciones sostenibles y ecológicas",
      "Servicios especializados en cremación eco-friendly",
    ],
    image: slide2,
  },
  estandar: {
    title: "Plan Estándar Tradicional",
    description:
      "El plan estándar cubre los servicios tradicionales con opciones personalizables para entierros o cremaciones.",
    features: [
      "Director de funerales profesional",
      "Uso de instalaciones",
      "Ataúd de alta calidad",
      "Paquete conmemorativo",
      "Transporte estándar",
      "Asistencia para certificados",
      "Soporte las 24 horas",
    ],
    whyChoose: [
      "Ideal para servicios tradicionales",
      "Opciones de entierro o cremación",
      "Ajustable según las necesidades del cliente",
    ],
    image: slide2,
  },
  silver: {
    title: "Plan Silver",
    description:
      "Un plan mejorado con más opciones para personalizar el servicio y crear una despedida memorable.",
    features: [
      "Director de funerales dedicado",
      "Sala velatoria privada",
      "Ataúd premium o urna de cremación",
      "Transporte de lujo",
      "Memorial personalizado",
      "Paquete conmemorativo de alta calidad",
      "Asistencia legal",
    ],
    whyChoose: [
      "Servicios de lujo",
      "Opción para personalizar cada detalle",
      "Atención especial para cada familia",
    ],
    image: slide2,
  },
  black: {
    title: "Plan Black",
    description:
      "Un plan premium para quienes buscan la máxima personalización y servicios de lujo.",
    features: [
      "Director de funerales exclusivo",
      "Sala velatoria de lujo",
      "Ataúd personalizado o urna de diseño",
      "Transporte en limusina",
      "Paquete conmemorativo exclusivo",
      "Servicio legal completo",
      "Soporte emocional especializado",
    ],
    whyChoose: [
      "El plan más exclusivo",
      "Máxima personalización de los servicios",
      "Soporte de lujo en cada etapa del proceso",
    ],
    image: slide2,
  },
  golden: {
    title: "Plan Golden ",
    description:
      "El plan más exclusivo, diseñado para aquellos que desean una experiencia de lujo y atención personalizada.",
    features: [
      "Servicios completos de planificación funeraria",
      "Sala velatoria privada y exclusiva",
      "Ataúd de lujo o urna de oro",
      "Transporte en vehículo de alta gama",
      "Paquete conmemorativo premium",
      "Asistencia legal personalizada",
      "Soporte emocional premium",
      "Asistencia para servicios internacionales",
    ],
    whyChoose: [
      "Lo mejor de lo mejor",
      "Servicios internacionales disponibles",
      "Soporte legal completo para trámites en el extranjero",
      "Transporte de lujo para un servicio inolvidable",
    ],
    image: slide2,
  },
};

// Define el número de teléfono de WhatsApp
const phoneNumber = "+56983221037"; // Reemplaza con el número de WhatsApp en formato internacional

// Función para manejar el clic en el botón
const handleClick = (planTitle) => {
  const message = encodeURIComponent(`Hola, me gustaría solicitar información sobre el plan ${planTitle}.`); // Mensaje personalizado según el plan
  const whatsappLink = `https://wa.me/${phoneNumber}/?text=${message}`;

  // Redirigir al usuario a WhatsApp con el mensaje predefinido
  window.open(whatsappLink, '_blank');
};

// Componente para las características individuales
const FeatureItem = ({ feature }) => (
  <div className="flex items-start space-x-3">
    <FaCheck className="h-6 w-6 text-[#DBAC5B]" />
    <span className="text-gray-700">{feature}</span>
  </div>
);

const handleButtonClick = () => {
  // Guardar una señal específica en localStorage cuando se haga clic en este botón
  localStorage.setItem('navigateToServices', 'true');
};

export default function PlanDetails() {
  const { planId } = useParams();
  const plan = plansData[planId];

  if (!plan) {
    return <p>Plan no encontrado</p>;
  }

  return (
    <div className="py-12 md:py-24 lg:py-20 px-4 sm:px-6 lg:px-8 overflow-x-hidden">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col items-center space-y-4 text-center p-0 mb-6">
        <img 
      src={logon}
      id="DesdeAca"
      alt="Funeraria Coquimbo"
      className=" h-24  md:h-24 transition-transform duration-300 ease-in-out hover:scale-105"
     />
        </div>

        {/* Sección de imagen y descripción */}
        <div className="flex flex-col lg:flex-row gap-12 mb-10">
          <div className="relative w-full lg:w-1/2">
            <img
              src={plan.image}
              alt={plan.title}
              className="rounded-lg shadow-xl object-cover w-full h-auto"
            />
          </div>
          <div className="flex flex-col justify-center w-full lg:w-1/2 text-center lg:text-left">
            <h2 className="text-4xl md:text-5xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 mb-6">
              {plan.title}
            </h2>
            <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 mb-8 text-base md:text-lg leading-relaxed">
              {plan.description}
            </p>
            <button
              onClick={() => handleClick(plan.title)} // Pasar correctamente el título del plan
              className="w-full sm:w-auto py-3 px-8 border rounded-md transition-all border-[#A0A0A0] mb-1 bg-[#DBAC5B] text-white flex items-center justify-center hover:text-[#A0A0A0]"
            >
              Solicitar Más Información
              <FaArrowRight className="ml-2" size={20} />
            </button>
            <p className="text-sm text-center text-gray-500">
              Sin compromiso - Estamos aquí para ayudar 24/7
            </p>
          </div>
        </div>

        {/* Features Section */}
        <section className="mb-1 rounded-lg mb-12">
          <div className="border-b border-gray-300 p-6 text-center ">
            <h3 className="text-3xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700">
              Características del Plan
            </h3>
          </div>
          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-y-6 lg:grid-cols-4 gap-x-6 justify-items-start">
            {plan.features.map((feature, index) => (
              <FeatureItem key={index} feature={feature} />
            ))}
          </div>
        </section>

        {/* Simple Process Section */}
        <div className="flex flex-col md:flex-row gap-12 mb-20">
          <div className="p-4 md:w-1/2  text-center md:text-left">
            <h3 className="text-2xl font-semibold ml-1 text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 mb-4">
              Proceso Sencillo
            </h3>
            <div className="p-0">
              <ol className="space-y-4 ml-0">
                {[
                  "Contáctenos para una consulta inicial gratuita",
                  "Discutimos sus necesidades y personalizamos el plan",
                  "Nos encargamos de todos los arreglos necesarios",
                  "Usted se enfoca en honrar a su ser querido",
                  "Proporcionamos apoyo continuo después del servicio",
                ].map((step, index) => (
                  <li key={index} className="flex items-start">
                    <span className="bg-[#DBAC5B] text-white rounded-full w-6 h-6 flex items-center justify-center mr-2">
                      {index + 1}
                    </span>
                    <span className="text-gray-700 text-base text-left ml-1 md:text-lg">
                      {step}
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          </div>

          <div className="p-4 md:w-1/2 text-center md:text-left ">
            <h3 className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 ml-1 mb-4">
              ¿Por qué elegir el {plan.title}?
            </h3>
            <div className="p-0">
              <ul className="space-y-4">
                {plan.whyChoose.map((item, index) => (
                  <li key={index} className="flex items-start">
                    <FaInfoCircle className="h-6 w-6 mr-2 text-[#DBAC5B]" />
                    <span className="text-gray-700 text-base text-left md:text-lg">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Final Call to Action Section */}
        <div className="mb-10 text-center rounded-lg">
          <h2 className="text-3xl md:text-4xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 mb-6">
            ¿Se adapta este plan a sus necesidades?
          </h2>
          <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 mb-6 text-base text-xl">
            Entendemos que cada situación es única. Si necesita explorar otras opciones, estamos aquí para ayudarle a encontrar el plan perfecto.
          </p>
          <div className="flex justify-center">
      <Link
        to="/"
        onClick={handleButtonClick} // Asignar la función al evento onClick
        className="w-full sm:w-auto py-2 px-8 border rounded-md transition-all border-[#A0A0A0] bg-[#DBAC5B] text-white flex items-center justify-center hover:text-[#A0A0A0]"
      >
        Ver Más Planes <FaArrowRight className="ml-2" />
      </Link>
    </div>
        </div>
      </div>
    </div>
  );
}